import makeStyles from '@mui/styles/makeStyles';

export const dayBadgeStyles = (background?: string, topPercent?: number) =>
  makeStyles(() => ({
    stackCard: {
      width: "100%",
      position: "absolute",
      top: `calc(${topPercent || 0}% - 2px)`,
      padding: "8px 16px",
    },
    groupedCard: {
      background,
      borderRadius: "12px",
      cursor: "pointer",
      width: "100%",
      overflow: "hidden",
      "&:hover": {
        boxShadow: "0px 0px 12px rgba(147, 169, 189, 0.25)",
        zIndex: "50",
      },
    },
    customerName: {
      font: "normal 500 14px/21px Manrope",
      color: "#465869",
      whiteSpace: "nowrap",
    },
    startDate: {
      font: "normal 500 12px/19px Manrope",
      color: "#465869",
      whiteSpace: "nowrap",
    },
    container: {
      padding: "10px 12px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      gap: "4px",
    },
    startsAt: {
      font: "normal 700 12px/19px Manrope",
      color: "#465869",
      whiteSpace: "nowrap",
    },
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
      gap: "12px",
    },
  }));
